import { GATEWAY_ROUTE_VISION_REGISTER_URL } from '@/core/const/gatewayRoutes.const'
import { postJson } from '@/core/utils/fetch'

import type { RegisterVisionUrlPayload } from './interfaces/registerVisionUrlPayload.interface'
import { buildUrl, type GatewayConfig } from './libraries.api'

export const registerVisionUrl = async (config: GatewayConfig, payload: RegisterVisionUrlPayload): Promise<void> => {
  const url = `${buildUrl(config)}/${GATEWAY_ROUTE_VISION_REGISTER_URL}`
  await postJson(url, payload)
}
